<layout-container>
  <div class="welcome-screen-headers flex flex-col flex-start-center gap-24">
    <h1 class="typography-small-header font-bold" data-test-id="welcome-screen-main-header">Welcome to myDarize!</h1>
    <p data-test-id="welcome-screen-sub-header" class="text-center">
      Here you can create your CV.<br>
      Remember that the more effort you put into your CV preparation the better job conditions we are likely to negotiate for you.
    </p>
  </div>
  <div class="welcome-screen-actions flex flex-center-center">
    <button
      [disableRipple]="true"
      (click)="letMeIn()"
      class="button-hidden-icon"
      color="accent"
      data-test-id="welcome-skip-btn"
      mat-flat-button
    >
      Start
    </button>
  </div>
</layout-container>
